import { css } from 'styled-components';

const bold56 = css`
  font-weight: 600;
  font-size: 3.5rem;
  line-height: 132%;
`;

const bold36 = css`
  font-weight: 600;
  font-size: 2.25rem;
  line-height: 132%;
`;

const bold24 = css`
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 132%;
`;

const bold18 = css`
  font-weight: 600;
  font-size: 1.125rem;
  line-height: 132%;
`;

const reg24 = css`
  font-weight: 300;
  font-size: 1.5rem;
  line-height: 132%;
`;

const reg18 = css`
  font-weight: 300;
  font-size: 1.125rem;
  line-height: 168%;
`;

const reg14 = css`
  font-weight: 300;
  font-size: 0.875rem;
  line-height: 168%;
`;

const m_bold56 = css`
  font-weight: 600;
  font-size: 2.25rem;
  line-height: 132%;
`;

const m_bold36 = css`
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 132%;
`;

const m_bold24 = css`
  font-weight: 600;
  font-size: 1.125rem;
  line-height: 132%;
`;

const m_bold18 = css`
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 132%;
`;

const m_reg24 = css`
  font-weight: 300;
  font-size: 1.125rem;
  line-height: 132%;
`;

const m_reg18 = css`
  font-weight: 300;
  font-size: 0.875rem;
  line-height: 154%;
`;

export {
  bold18,
  bold24,
  bold36,
  bold56,
  reg14,
  reg18,
  reg24,
  m_bold18,
  m_bold24,
  m_bold36,
  m_bold56,
  m_reg18,
  m_reg24,
};
